export default __webpack_public_path__ + "static/media/0.43.e7ad3019.jpg";